import { BrowserProvider } from 'ethers';
export const getBrowserProvider = (provider, chainId) => {
    return new BrowserProvider(provider, chainId);
};
